import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex, FilterButton, Fieldset } from "@base-ui";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];

//use when you can check multiple filters
var FilterFieldset = function FilterFieldset(props) {
  var id = props.id,
    legend = props.legend,
    hideLegend = props.hideLegend,
    options = props.options,
    selected = props.selected,
    updateSelected = props.updateSelected,
    icon = props.icon,
    className = props.className;
  var filters = options.map(function (option) {
    return /*#__PURE__*/_jsx(FilterButton, {
      id: "".concat(id, "-filter-").concat(option.id),
      className: className,
      label: option.label,
      checked: selected.includes(option.id),
      onChange: function onChange(check) {
        return updateSelected(check, option.id);
      },
      m: "5px"
    }, option.id);
  });
  return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    legend: legend,
    hideLegend: hideLegend
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    className: className,
    icon: icon,
    children: /*#__PURE__*/_jsx(Flex.Row, {
      flexWrap: "wrap",
      children: filters
    })
  }));
};
FilterFieldset.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  icon: PropTypes.string
};
export default FilterFieldset;